import { render, staticRenderFns } from "./bpBjLeadoutList.vue?vue&type=template&id=5e4d0064&"
import script from "./bpBjLeadoutList.vue?vue&type=script&lang=js&"
export * from "./bpBjLeadoutList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports